export const collapseSchema = {
  category: 'container',
  icon: 'card',
  options: {
    accordion: true,
    border: true,
    customClass: '',
    defaultValue: '',
    expandName: '',
    hidden: false,
    label: 'collapse',
    name: 'collapse-item-107387',
  },
  type: 'collapse',
  widgetList: [
    {
      category: 'container',
      icon: 'card',
      id: 'collapse-item-107387',
      internal: true,
      options: {
        border: true,
        disabled: false,
        expand: true,
        icon: '',
        'is-link': true,
        label: 'collapse-item-1',
        'label-class': '',
        'lazy-render': false,
        name: 'collapse-item-107387',
        readonly: false,
        size: '',
        title: 'collapseItem',
        'title-class': '',
        value: '',
        'value-class': '',
      },
      type: 'collapse-item',
      widgetList: [],
    },
  ],
};

export const collapseItemSchema = {
  category: 'container',
  icon: 'card',
  internal: true,
  options: {
    border: true,
    disabled: false,
    expand: true,
    icon: '',
    'is-link': true,
    label: '',
    'label-class': '',
    'lazy-render': false,
    readonly: false,
    size: '',
    title: 'collapseItem',
    'title-class': '',
    value: '',
    'value-class': '',
  },
  type: 'collapse-item',
  widgetList: [],
};

export const alertSchema = {
  formItemFlag: false,
  icon: 'alert',
  options: {
    closable: true,
    customClass: '',
    hidden: false,
    name: '',
    onClose: '',
    showIcon: false,
    title: 'Good things are coming...',
    type: 'info',
  },
  type: 'alert',
};
